import { render } from "./News02.vue?vue&type=template&id=6ee8e4bd&scoped=true"
import script from "./News02.vue?vue&type=script&lang=js"
export * from "./News02.vue?vue&type=script&lang=js"

import "./News02.vue?vue&type=style&index=0&id=6ee8e4bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee8e4bd"]])

export default __exports__